import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DataTableColumn, DataTableComponent, DataTablePageChangedEvent } from '@shared/components/data-table.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { AffiliateListItemResponse } from '../../affiliate.model';
import { ActionMenu } from "@shared/components/action-menu/action-menu";
import { useAffiliateActionMenu } from "./affiliate-action-menu-composable";

export type AffiliatesPageChangedEvent = DataTablePageChangedEvent;

@Component({
  selector: 'affiliate-table',
  imports: [DataTableComponent, ActionMenu, ...SharedMaterialUIModule],
  templateUrl: './affiliate-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AffiliateTableComponent {
  protected readonly columns: DataTableColumn<AffiliateListItemResponse>[] = [
    {
      id: 'name',
      header: 'Name',
      value: (affiliate) => `${affiliate.name} ${affiliate.surname}`.trim(),
      cellClass: 'px-3 py-3 font-medium text-slate-900',
    },
    {
      id: 'emailAddress',
      header: 'Email',
      value: (affiliate) => affiliate.emailAddress,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'contactNumber',
      header: 'Contact Number',
      value: (affiliate) => affiliate.contactNumber,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'affiliateDisciplineName',
      header: 'Discipline',
      value: (affiliate) => affiliate.affiliateDisciplineName,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'experience',
      header: 'Experience (years)',
      value: (affiliate) => affiliate.experience,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'isActive',
      header: 'Status',
      value: (affiliate) => (affiliate.isActive ? 'Active' : 'Inactive'),
      cellClass: 'px-3 py-3',
    },
  ];

  readonly affiliates = input<AffiliateListItemResponse[]>([]);
  readonly loading = input(false);
  readonly searchTerm = input('');
  readonly pageNumber = input(1);
  readonly pageSize = input(25);
  readonly totalCount = input(0);
  readonly totalPages = input(0);
  readonly canActivate = input(false);
  readonly canDeactivate = input(false);
  readonly canUpdate = input(false);
  readonly actionAffiliateId = input<string | null>(null);

  readonly refreshed = output<void>();
  readonly searchChanged = output<string>();
  readonly pageChanged = output<AffiliatesPageChangedEvent>();
  readonly toggled = output<AffiliateListItemResponse>();
  readonly actionMenuItems = useAffiliateActionMenu().affiliateActionMenuItems;
     readonly actions: Record<string, any> = {
      'toggled': this.toggled,
    };
}
